export type SinisterSector = "cobranca" | "juridico";

export const SECTOR_OPTIONS: { value: SinisterSector; label: string }[] = [
	{ value: "cobranca", label: "Cobrança" },
	{ value: "juridico", label: "Jurídico" },
];

export const getSectorLabel = (sector: SinisterSector | string): string =>
	SECTOR_OPTIONS.find((option) => option.value === sector)?.label ?? sector;
